// This file was once generated when you created this area
// but you can edit it freely

const baseRoute = '/fleet-maintenance'

export const FleetMaintenanceAreaPaths = {
  MainInspections: 'main-inspections',
  MileageBasedInspections: 'mileage-based-inspections',
  Vic: 'vic',
  WorkOrders: 'work-orders',
  Automations: 'automations',
  AutomationsCreate: 'new',
  Damages: 'damages',
  DamagesViewReport: ':reportId/view',
  DamagesNotFound: '/not-found',
}

const damagesRoute = `${baseRoute}/${FleetMaintenanceAreaPaths.Damages}`
const automationsRoute = `${baseRoute}/${FleetMaintenanceAreaPaths.Automations}`

export const FleetMaintenanceAreaRoutes = {
  route: baseRoute,
  MainInspections: `${baseRoute}/${FleetMaintenanceAreaPaths.MainInspections}`,
  MileageBasedInspections: `${baseRoute}/${FleetMaintenanceAreaPaths.MileageBasedInspections}`,
  Vic: `${baseRoute}/${FleetMaintenanceAreaPaths.Vic}`,
  WorkOrders: `${baseRoute}/${FleetMaintenanceAreaPaths.WorkOrders}`,
  Automations: automationsRoute,
  AutomationsCreate: `${automationsRoute}/${FleetMaintenanceAreaPaths.AutomationsCreate}`,
  Damages: `${baseRoute}/${FleetMaintenanceAreaPaths.Damages}`,
  DamagesViewReport: `${damagesRoute}/${FleetMaintenanceAreaPaths.DamagesViewReport}`,
  DamagesNotFound: `${damagesRoute}/${FleetMaintenanceAreaPaths.DamagesNotFound}`,
}
